export default function isUs(pathname) {
  return pathname?.includes('/en-us/') || pathname?.includes('/us/');
}
